const WatchLiveNotDeal = () =>
  import('@/views/main/helper/watchLiveNotDeal/WatchLiveNotDeal.vue')
export default {
  path: '/main/helper/watchLiveNotDeal',
  name: 'WatchLiveNotDeal',
  component: WatchLiveNotDeal
}